import React from 'react';

// Keep children mounted when collapsed so unsaved setup/training state is preserved.
export default function SetupPanel({ title, description, children, defaultOpen = false, className = '', id }) {
  return <details id={id} className={`setup-panel ${className}`} open={defaultOpen || undefined}>
    <summary><span><strong>{title}</strong>{description && <small>{description}</small>}</span></summary>
    <div className="setup-panel__body">{children}</div>
  </details>;
}
